'use client'

import type { ReactNode } from 'react'

import { useLanguageFromUrl } from '@/core/hooks/useLanguageFromUrl'

interface LanguageProviderProps {
  children: ReactNode
}

const LanguageProvider = ({ children }: LanguageProviderProps) => {
  // این هوک زبان رو از URL تشخیص میده و i18n رو update میکنه
  useLanguageFromUrl()

  return <>{children}</>
}

export default LanguageProvider
